import { useTranslation } from 'react-i18next';
import { Toggle } from 'rsuite';
import clsx from 'clsx';
import React from 'react';

import './GeneralSwitches.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { WhisperComponent } from '../developers/page-components/WhisperComponent';
import {
  GENERAL_FORM_FIELDS,
  GENERAL_FORM_FIELDS_NAMES,
  FUNDING_CONFIG_FORM_FIELDS,
  FUNDING_CONFIG_FORM_FIELDS_NAMES
} from '../../constants/merchant/general-form';

interface ISwitchesProps {
	formik: any;
	formEditStatus: boolean;
	title: GENERAL_FORM_FIELDS_NAMES | FUNDING_CONFIG_FORM_FIELDS_NAMES | string;
	formField: GENERAL_FORM_FIELDS | FUNDING_CONFIG_FORM_FIELDS | string;
	tooltip?: string;
}

export const GeneralSwitches = (props: ISwitchesProps): JSX.Element => {
	const { title, formik, formEditStatus, formField, tooltip } = props;
	const { t } = useTranslation();

	const isDisabled = formField === GENERAL_FORM_FIELDS.INFORMATIONAL_3DS
		? !formEditStatus || !formik.getFieldProps(GENERAL_FORM_FIELDS.ENABLE_GLOBAL_3DS).value
		: !formEditStatus;

	const handleChange = (checked: boolean): void => {
		if (formField === GENERAL_FORM_FIELDS.ENABLE_GLOBAL_3DS && checked === false) {
			formik.setTouched({ [GENERAL_FORM_FIELDS.INFORMATIONAL_3DS]: false });
			formik.setFieldValue(GENERAL_FORM_FIELDS.ENABLE_GLOBAL_3DS, false);
			formik.setFieldValue(GENERAL_FORM_FIELDS.INFORMATIONAL_3DS, false);
		} else {

			formik.setTouched({ ...formik.touched, [formField]: true });
			formik.setFieldValue(formField, checked);
		}
	};

	return (
		<div className="d-flex justify-content-between">
			<div className="me-3 mb-3 fs-7">
				<span className={clsx('me-1', isDisabled && 'text-muted' )}>{t(title)}</span>
				{
					tooltip && (
						<WhisperComponent
							isTooltip
							whisperText={tooltip}
							mainText={
								<FontAwesomeIcon
									icon={faQuestionCircle}
									className={clsx('cursor-pointer', isDisabled && 'text-muted')}
									width={12}
								/>
							}
						/>
					)
				}

			</div>

			<Toggle
				size="md"
				checked={formik.getFieldProps(formField)?.value}
				className={clsx(formik.getFieldProps(formField).value ? 'is-active' : '', isDisabled && 'toggle-muted')}
				onChange={handleChange}
				disabled={isDisabled}
			/>
		</div>

	);
};
